import React, {Component} from 'react';
import LastOrder from "../../../Site/UserProfile/LastOrderView/ViewSingleCustomerOrder/ViewSingleCustomerOrder"

class LastOrderCaller extends Component {

    render() {
        return (
            <LastOrder userId={this.props.match.params.userId}/>
        );
    }
}
export default LastOrderCaller;


// WEBPACK FOOTER //
// ./src/components/Admin/AllCustomers/AllCustomersRow/LastOrderCaller.js